<template>
  <div class="container-fluid">
    <system-custom-notifications-create-notification v-if="this.step === 1"/>
    <system-custom-notifications-select-users v-if="this.step === 2"/>
    <system-custom-notifications-send-notification v-if="this.step === 3"/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SystemCustomNotificationsCreateNotification from './SystemCustomNotificationsCreateNotification'
import SystemCustomNotificationsSendNotification from './SystemCustomNotificationsSendNotification'
import SystemCustomNotificationsSelectUsers from './SystemCustomNotificationsSelectUsers'

export default {
  components: {
    SystemCustomNotificationsCreateNotification,
    SystemCustomNotificationsSendNotification,
    SystemCustomNotificationsSelectUsers
  },

  computed: {
    ...mapState('notification', ['step'])
  },

  beforeDestroy () {
    this.setSelectedStars([])
  },

  methods: {
    ...mapActions('filtering', ['setSelectedStars'])
  }
}
</script>
